<ng-container *ngIf="{ value: state$ | async } as stateWrapper">
    <div class="container" *ngIf="stateWrapper.value as state">
        <div class="header">
            <div>{{ time$ | async }}, <ng-container i18n>Connected players</ng-container>: {{ state.playerCount || 0 }}</div>
            <div class="version"><ng-container i18n>Version</ng-container>: {{ version }}</div>
            <div i18n>
                {{ state.configuration.tableId }}, Baccarat,
                {{ state.croupier?.name ?? '-' }}
            </div>
        </div>
        <div class="table-and-chat">
            <div class="table-container">
                <app-phase-title
                    [phase]="state.roundState.phase"
                    [outcome]="state.tableState?.outcome"
                    [nextCardPosition]="state.tableState?.nextCardPosition"
                    [burnedCount]="state.shoeChangeState?.burnedCount ?? 0"
                    [totalToBurnCount]="state.shoeChangeState?.totalToBurnCount ?? 0"
                    [winnerHandValue]="
                        (state.tableState?.outcome === BaccaratOutcome.BankerWin
                            ? state.tableState?.bankerHandValue
                            : state.tableState?.playerHandValue) ?? 0
                    "
                ></app-phase-title>

                <app-error-panel
                    *ngIf="state.roundState?.phase === BaccaratPhase.RoundError"
                    [errorCode]="state.roundState.errorCode"
                ></app-error-panel>
                <app-closed-table *ngIf="state.roundState?.phase === BaccaratPhase.WaitingForCroupier"></app-closed-table>
                <app-waiting-for-players *ngIf="state.roundState?.phase === BaccaratPhase.WaitingForPlayers"></app-waiting-for-players>
                <app-round-voided *ngIf="state.roundState?.phase === BaccaratPhase.RoundVoid"></app-round-voided>
                <app-shoe-change *ngIf="state.roundState?.phase === BaccaratPhase.ShoeChange"></app-shoe-change>
                <app-burn-cards
                    *ngIf="state.roundState?.phase === BaccaratPhase.CardBurn"
                    [card]="state.shoeChangeState?.card"
                    [burnedCardsCount]="state.shoeChangeState?.burnedCount || 0"
                ></app-burn-cards>

                <app-count-down
                    *ngIf="state?.roundState?.phase === BaccaratPhase.BetsOpen || state?.roundState?.phase === BaccaratPhase.BetsClosed"
                    [initialTimeInSeconds]="state.roundState.remainingBettingTimeInSeconds ?? state.configuration.bettingWindowInSeconds"
                ></app-count-down>
                <app-baccarat-table
                    *ngIf="
                        state.roundState?.phase === BaccaratPhase.NewRoundPreparation ||
                        state.roundState?.phase === BaccaratPhase.BetsOpen ||
                        state.roundState?.phase === BaccaratPhase.BetsClosed ||
                        state.roundState?.phase === BaccaratPhase.DealingCards ||
                        state.roundState?.phase === BaccaratPhase.RoundEnd
                    "
                    [cards]="this.state.tableState?.cards"
                    [bankerHandValue]="this.state.tableState?.bankerHandValue"
                    [playerHandValue]="this.state.tableState?.playerHandValue"
                    [nextCardPosition]="this.state.tableState?.nextCardPosition"
                    [outcome]="this.state.tableState?.outcome"
                ></app-baccarat-table>
                <div class="table-footer" *ngIf="state.roundState.phase !== BaccaratPhase.WaitingForCroupier">
                    <div i18n>Game round ID: {{ state.roundState.roundId ?? '-' }}</div>
                    <div>
                        <button
                            i18n
                            mat-raised-button
                            color="primary"
                            class="important"
                            [class.highlight]="state.flagsState.roundFlagged"
                            [disabled]="state.flagsState.roundFlagged"
                            (click)="onFlagGameClick(flagGameButton)"
                            #flagGameButton
                        >
                            Flag game
                        </button>
                        <button
                            *ngIf="false"
                            i18n
                            mat-raised-button
                            color="primary"
                            [class.highlight]="state.flagsState.roundBetsFree"
                            [disabled]="state.flagsState.roundBetsFree"
                            (click)="onFreeGameClick(freeGameButton)"
                            #freeGameButton
                        >
                            Free game
                        </button>
                    </div>
                </div>
            </div>
            <app-chat
                class="chat"
                *ngIf="state.roundState.phase !== BaccaratPhase.WaitingForCroupier"
                [chatEnabled]="state.flagsState.chatEnabled"
                [messages]="state.chatMessages"
            ></app-chat>
        </div>
        <div class="footer" *ngIf="state.roundState.phase !== BaccaratPhase.WaitingForCroupier">
            <div class="footer-left">
                <button
                    i18n
                    *ngIf="false"
                    mat-raised-button
                    color="primary"
                    class="important"
                    [class.highlight]="state.flagsState.supervisorCalled"
                    [disabled]="state.flagsState.supervisorCalled"
                    (click)="onCallSupervisorClick(callSupervisorButton)"
                    #callSupervisorButton
                >
                    Call supervisor
                </button>
                <button
                    i18n
                    mat-raised-button
                    color="primary"
                    [class.highlight]="state.flagsState.tableClosingRequested"
                    [disabled]="state.flagsState.tableClosingRequested"
                    (click)="onCloseTableClick(closeTableButton)"
                    #closeTableButton
                >
                    Close table
                </button>
                <button
                    i18n
                    *ngIf="
                        state.roundState.phase === BaccaratPhase.BetsOpen ||
                        state.roundState.phase === BaccaratPhase.BetsClosed ||
                        state.roundState.phase === BaccaratPhase.DealingCards
                    "
                    mat-raised-button
                    [color]="state.shoeChangeState?.cutCardDrawn ? 'accent' : 'primary'"
                    (click)="onChangeShoeClick(changeShoeButton)"
                    #changeShoeButton
                >
                    Void game & Change shoe
                </button>
            </div>
            <div class="footer-right">
                <button
                    i18n
                    mat-raised-button
                    color="primary"
                    (click)="state.flagsState.chatEnabled ? onDisableChatClick(chatButton) : onEnableChatClick(chatButton)"
                    #chatButton
                >
                    @if (state.flagsState.chatEnabled) {
                        Disable chat
                    } @else {
                        Enable chat
                    }
                </button>
            </div>
        </div>
    </div>
    <div class="no-connection" *ngIf="!stateWrapper.value" i18n>Connecting to table ...</div>
</ng-container>
